import { type FC } from 'react';
import {
  Avatar,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Check } from '@mui/icons-material';

import {
  SelectDialog,
  type SelectDialogProps,
} from '#packages/web/foundations/feedback/select-dialog';
import { Theme, type ThemeName } from '#packages/web/theme';

export type SelectThemeDialogProps = Pick<
  SelectDialogProps<ThemeName>,
  'onFormCancel' | 'onFormSubmit' | 'open' | 'initialValue'
>;

export const SelectThemeDialog: FC<SelectThemeDialogProps> = ({
  open,

  initialValue,

  onFormCancel,
  onFormSubmit,
}) => (
  <SelectDialog
    title="Select Theme"
    open={open}
    initialValue={initialValue}
    onFormCancel={onFormCancel}
    onFormSubmit={onFormSubmit}>
    <List>
      {Object.keys(Theme.list).map((themeName) => (
        <ListItemButton
          key={themeName}
          onClick={onFormSubmit.bind(undefined, themeName as ThemeName)}>
          <ListItemIcon>{initialValue === themeName && <Check />}</ListItemIcon>
          <ListItemText
            primary={
              <Typography sx={{ textTransform: 'capitalize' }}>
                {themeName}
              </Typography>
            }
          />
          <Avatar
            sx={{
              bgcolor: Theme.list[themeName as ThemeName].palette.primary.main,
            }}>
            &nbsp;
          </Avatar>
        </ListItemButton>
      ))}
    </List>
  </SelectDialog>
);
